import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Contractdate } from './contractdate.model';
import { ContractdatePopupService } from './contractdate-popup.service';
import { ContractdateService } from './contractdate.service';
import { Contract, ContractService } from '../contract';

@Component({
    selector: 'jhi-contractdate-dialog',
    templateUrl: './contractdate-dialog.component.html'
})
export class ContractdateDialogComponent implements OnInit {

    contractdate: Contractdate;
    authorities: any[];
    isSaving: boolean;

    contracts: Contract[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private contractdateService: ContractdateService,
        private contractService: ContractService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['contractdate']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contractService.query().subscribe(
            (res: Response) => { this.contracts = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.contractdate.id !== undefined) {
            this.contractdateService.update(this.contractdate)
                .subscribe((res: Contractdate) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.contractdateService.create(this.contractdate)
                .subscribe((res: Contractdate) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Contractdate) {
        this.eventManager.broadcast({ name: 'contractdateListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackContractById(index: number, item: Contract) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-contractdate-popup',
    template: ''
})
export class ContractdatePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private contractdatePopupService: ContractdatePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.contractdatePopupService
                    .open(ContractdateDialogComponent, params['id']);
            } else {
                this.modalRef = this.contractdatePopupService
                    .open(ContractdateDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate-dialog.component.ts